import React, {Component} from 'react';
import PropTypes from "prop-types";
import jquery from "jquery";
import Api from "./Api";
import WindowDimensions from "./WindowDimensions";
import ReactHtmlParser from "react-html-parser";
import StaticFunctions from "./StaticFunctions";
import LoadingSplash from "../globalComponents/LoadingSplash";

class CurlContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        url: PropTypes.string.isRequired
    };

    static defaultProps = {
        id: 'curlBox',
        classes: '',
        removeElements: [],
        style: {}
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            requestState: null,
            startUrl: props.url,
            url: props.url,
            page: null,
            pointer: null,
            chronice: []
        };

        this.translate = this.props.baseData.translate;

        this.requestPage = this.requestPage.bind(this);
        this.changeUrl = this.changeUrl.bind(this);

    }

    componentWillMount() {

        this.requestPage();

    }

    requestPage() {

        if (this.state.requestState === 'requested') return null;

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id,
            url: this.state.url
        };

        const callback = function (res) {
            if (res) {
                this.setState({
                    requestState: 'ready',
                    page: res
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
        }, () => {
            this.api.request('GetCurlPage', params, callback, null);
        });

    }

    changeUrl(url) {

        this.setState({
            url
        }, this.requestPage);

    }

    getNotFoundMassage() {

        return '<div class="modulWarning">' + this.translate('pageNotFound') + ' ' + this.translate('backTo') + ' <a href="' + this.state.startUrl + '">' + this.translate('home') + '</a>.</div>';

    }

    renderCurl() {

        if (!this.state.page) return null;

        //return ReactHtmlParser(this.state.page);

        //return <div dangerouslySetInnerHTML={{ __html: this.state.page }} />;

        //return this.state.page;

        const head = this.state.page.head;
        const body = (this.state.page.body) ? this.state.page.body : this.getNotFoundMassage();

        const header = jquery(head);
        const content = jquery(body);
        const mainTitle = content.find('h1#title-text').removeAttr('href');
        const html = jquery('<html>');

        this.props.removeElements.forEach(
            (element) => {
                header.find(element).remove();
                content.find(element).remove();
            }
        );

        content.find('div#title-heading').html(mainTitle);

        jquery('#' + this.props.id + '.curlBox').on('click', 'a', (e) => {
            if (e) {
                let urlDomain = this.props.url.replace('http://', '').replace('https://', '').split(/[/?#]/)[0];
                let refDomain = e.target.href.replace('http://', '').replace('https://', '').split(/[/?#]/)[0];

                if (urlDomain === refDomain) {
                    this.changeUrl(e.target.href);
                } else {
                    window.open(e.target.href, '_blank');
                }

                return false;
            }
        });

        html.append('head').html(header);
        html.append('body').html(content);

        return (
            <html>
                <head>{ReactHtmlParser(head)}</head>
                <body>{ReactHtmlParser(html.html())}</body>
            </html>
        );

    }

    render() {

        const {id, classes, style, ...others} = {...this.props};
        const classNames = ['curlBox', classes].join(' ').trim();
        const content = this.renderCurl();

        if (this.state.requestState !== 'ready') {
            return (
                <div style={{padding: 20}}>
                    <LoadingSplash color="dark"/>
                </div>
            );
        } else {
            return (
                <div id={id} className={classNames} style={style}>
                    {content}
                </div>
            );
        }

    }

}

export default CurlContainer;